export function getQuantityLabel(
  reportType: { quantityAlias?: string | null; quantityAliasEn?: string | null } | null | undefined,
  language: string,
  fallback: string,
): string {
  if (!reportType) return fallback;
  if (language === 'he' && reportType.quantityAlias) return reportType.quantityAlias;
  if (language !== 'he' && reportType.quantityAliasEn) return reportType.quantityAliasEn;
  if (language !== 'he' && reportType.quantityAlias) return reportType.quantityAlias;
  return fallback;
}
